import React from 'react';
import BedBox from './BedBox';
import { DoorOpen, Edit2, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function RoomCard({ room, floor, beds, tenants, onBedClick, onDragStart, onDrop, onDragOver, dragTargetBedId, onEditRoom, onDeleteRoom }) {
  const roomBeds = beds.filter(b => b.roomId === room.id);
  const occupiedCount = roomBeds.filter(b => b.status === 'occupied').length;
  const vacantCount = roomBeds.length - occupiedCount;
  const occupancyPercent = roomBeds.length > 0 ? (occupiedCount / roomBeds.length) * 100 : 0;

  const getOccupancyColor = () => {
    if (occupancyPercent >= 80) return 'bg-red-100 border-red-300';
    if (occupancyPercent >= 50) return 'bg-yellow-100 border-yellow-300';
    return 'bg-green-100 border-green-300';
  };

  return (
    <div className={`border-2 rounded-xl p-4 ${getOccupancyColor()}`} data-testid={`room-${room.id}`}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <DoorOpen className="w-5 h-5 text-slate-700" />
          <h4 className="font-bold text-slate-900">Room {room.roomNumber}</h4>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs font-semibold px-2 py-1 bg-white rounded-full border border-slate-300">
            {room.roomType}
          </span>
          <span className={`text-xs font-bold px-2 py-1 rounded-full ${
            occupancyPercent >= 80 ? 'bg-red-200 text-red-800' :
            occupancyPercent >= 50 ? 'bg-yellow-200 text-yellow-800' :
            'bg-green-200 text-green-800'
          }`}>
            {Math.round(occupancyPercent)}%
          </span>
          <Button
            size="sm"
            variant="ghost"
            className="h-7 w-7 p-0"
            onClick={() => onEditRoom(room)}
            data-testid={`edit-room-${room.id}`}
          >
            <Edit2 className="w-4 h-4" />
          </Button>
          <Button
            size="sm"
            variant="ghost"
            className="h-7 w-7 p-0 text-red-600 hover:text-red-700 hover:bg-red-50"
            onClick={() => onDeleteRoom(room)}
            data-testid={`delete-room-${room.id}`}
          >
            <Trash2 className="w-4 h-4" />
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-3">
        {roomBeds.map((bed) => {
          const tenant = tenants.find(t => t.currentBedId === bed.id);
          return (
            <BedBox
              key={bed.id}
              bed={bed}
              room={room}
              floor={floor}
              tenant={tenant}
              onBedClick={onBedClick}
              onDragStart={onDragStart}
              onDrop={onDrop}
              onDragOver={onDragOver}
              isDragTarget={dragTargetBedId !== null && bed.id !== dragTargetBedId && bed.status === 'vacant'}
            />
          );
        })}
      </div>

      <div className="flex justify-between text-xs text-slate-700 pt-2 border-t border-slate-300">
        <span className="font-medium">Occupied: <span className="font-bold">{occupiedCount}</span></span>
        <span className="font-medium">Vacant: <span className="font-bold">{vacantCount}</span></span>
      </div>
    </div>
  );
}
